import { useState } from "react";
import { cn } from "@/lib/utils";

interface TagsPillsProps {
  tags: string[];
  className?: string;
  maxTags?: number;
}

export function TagsPills({ tags, className, maxTags = 5 }: TagsPillsProps) {
  const [expanded, setExpanded] = useState(false);

  if (!tags || tags.length === 0) return null;

  const displayTags = expanded ? tags : tags.slice(0, maxTags);
  const remaining = tags.length - maxTags;

  return (
    <div className={cn("flex flex-wrap gap-1.5", className)}>
      {displayTags.map((tag, index) => (
        <span 
          key={index} 
          className={cn(
            "text-xs font-medium px-2 py-0.5 rounded",
            "bg-[hsl(var(--sg7-surface-2))]",
            "border border-[hsl(var(--sg7-stroke-subtle))]",
            "text-[hsl(var(--sg7-text-muted))]"
          )}
        >
          {tag}
        </span>
      ))}
      {remaining > 0 && (
        <button 
          type="button"
          onClick={() => setExpanded(!expanded)}
          className={cn(
            "text-xs font-medium px-2 py-0.5 rounded cursor-pointer",
            "border border-[hsl(var(--sg7-stroke-subtle))]",
            "text-[hsl(var(--sg7-text-muted))] hover:text-[hsl(var(--sg7-text-primary))]",
            "transition-colors"
          )}
        >
          {expanded ? "−" : `+${remaining}`}
        </button>
      )}
    </div>
  );
}
